import { useToast } from '@chakra-ui/react'
import { useMemo } from 'react'

export const useToaster = () => {
  const toast = useToast()
  return useMemo(
    () => ({
      error: (options: { title: string; description: string }) => {
        toast({
          ...options,
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'bottom-right',
        })
      },
      warning: (options: { title: string; description: string }) => {
        toast({
          ...options,
          status: 'warning',
          duration: 5000,
          isClosable: true,
          position: 'bottom-right',
        })
      },
      success: (options: { title: string; description: string }) => {
        toast({
          ...options,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'bottom-right',
        })
      },
      info: (options: { title: string; description: string }) => {
        toast({
          ...options,
          status: 'info',
          duration: 8000,
          isClosable: true,
          position: 'bottom-right',
        })
      },
    }),
    [toast]
  )
}
